import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAuthState } from '../../interfaces/auth/IAuthState.ts';
import { IAuthUser } from '../../interfaces/auth/IAuthUser.ts';

const initialState: IAuthState = {
    user: null,
    accessToken: null,
    isAuthenticated: false,
    isLoading: true,
    rememberMe: false,
};
export const authSlice = createSlice({
    initialState: initialState,
    name: 'auth',
    reducers: {
        logout: (state) => {
            state.user = null;
            state.accessToken = null;
            state.isAuthenticated = false;
            state.rememberMe = false;
            state.isLoading = false;
        },
        setCredentials: (state, action: PayloadAction<{
            user: IAuthUser,
            accessToken: string,
            rememberMe: boolean,
        }>) => {
            state.user = action.payload.user;
            state.accessToken = action.payload.accessToken;
            state.isAuthenticated = true;
            state.rememberMe = action.payload.rememberMe;
            state.isLoading = false;
        },
    },
});

export const authActions = authSlice.actions;
